import Api from './Api'

export default class SessionController extends Api {
	static logout() {
		return fetch(`/sign_out`, {
			method: 'DELETE',
			credentials: 'same-origin',
		})
	}
}